<template>
    <f7-page class="page-report-date has-footer">
        <f7-navbar :sliding="false">
            <f7-nav-title sliding>BÁO CÁO</f7-nav-title>
        </f7-navbar>
        <f7-block inset class="mt-0 mb-2">
            <f7-segmented raised>
                <f7-button :active="tab_active === 'today'" @click.prevent="tab_active = 'today', report_date_to = report_date">
                    NGÀY {{ report_date | moment('DD/MM') }}
                </f7-button>
                <f7-button :active="tab_active === 'this_week'" @click.prevent="tab_active = 'this_week', getReportThisWeek()">
                    TUẦN NÀY
                </f7-button>
                <f7-button :active="tab_active === 'last_week'" @click.prevent="tab_active = 'last_week', getReportLastWeek()">
                    TUẦN TRƯỚC
                </f7-button>
                <f7-button style="width: 120px" :active="tab_active === 'custom'" @click.prevent="tab_active = 'custom'">
                    <f7-icon f7="calendar"></f7-icon>
                </f7-button>
            </f7-segmented>
        </f7-block>
        <f7-list inline-labels v-if="tab_active === 'today' || tab_active === 'custom'" class="mt-0">
            <f7-list-input
                :label="tab_active === 'today' ? 'Ngày' : 'Từ ngày'"
                type="datepicker"
                :placeholder="tab_active === 'today' ? 'Chọn ngày' : 'Từ ngày'"
                :value="[this.report_date]"
                @calendar:change="(values) => report_date = values[0]"
                :calendar-params="{dateFormat: 'dd/mm/yyyy', locale: 'vi-VN', closeOnSelect: true, openIn: 'customModal'}">
                <f7-icon slot="media" ios="f7:calendar"></f7-icon>
            </f7-list-input>
            <f7-list-input
                label="Đến ngày"
                type="datepicker"
                v-if="tab_active === 'custom'"
                placeholder="Đến ngày"
                :value="[this.report_date_to]"
                @calendar:change="(values) => report_date_to = values[0]"
                :calendar-params="{dateFormat: 'dd/mm/yyyy', locale: 'vi-VN', closeOnSelect: true, openIn: 'customModal'}">
                <f7-icon slot="media" ios="f7:calendar"></f7-icon>
            </f7-list-input>
        </f7-list>
        <div class="data-table card sm bordered">
            <table>
                <thead>
                <tr>
                    <th colspan="5" class="text-align-center p-3">{{ report_date_string }}</th>
                </tr>
                <tr>
                    <th>KHÁCH HÀNG</th>
                    <th class="text-align-right" v-if="!!user_info.user_configs.display_mn || !!user_info.user_configs.display_mn_mtay || !!user_info.user_configs.display_mn_buonme">
                        MN
                    </th>
                    <th class="text-align-right" v-if="!!user_info.user_configs.display_mt || !!user_info.user_configs.display_mt_mtay || !!user_info.user_configs.display_mt_buonme">
                        MT
                    </th>
                    <th class="text-align-right" v-if="!!user_info.user_configs.display_mb || !!user_info.user_configs.display_mb_mtay || !!user_info.user_configs.display_mb_ngan || !!user_info.user_configs.display_mb_buonme">
                        MB
                    </th>
                    <th class="text-align-right">T.CỘNG</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="(cust, idx) in _.orderBy(customers, ['type'], ['asc'])" :key="idx">
                    <td>{{ cust.fullname }}</td>
                    <td class="text-align-right" v-if="!!user_info.user_configs.display_mn || !!user_info.user_configs.display_mn_mtay || !!user_info.user_configs.display_mn_buonme">
                        {{ getSumByCustomerId(cust.id, 'mn', cust.type) | numeral('0,0[.]0') }}
                    </td>
                    <td class="text-align-right" v-if="!!user_info.user_configs.display_mt || !!user_info.user_configs.display_mt_mtay || !!user_info.user_configs.display_mt_buonme">
                        {{ getSumByCustomerId(cust.id, 'mt', cust.type) | numeral('0,0[.]0') }}
                    </td>
                    <td class="text-align-right" v-if="!!user_info.user_configs.display_mb || !!user_info.user_configs.display_mb_mtay || !!user_info.user_configs.display_mb_ngan || !!user_info.user_configs.display_mb_buonme">
                        {{ getSumByCustomerId(cust.id, 'mb', cust.type) | numeral('0,0[.]0') }}
                    </td>
                    <td class="text-align-right">
                        {{
                            (getSumByCustomerId(cust.id, 'mn', cust.type) + getSumByCustomerId(cust.id, 'mt', cust.type) +
                                getSumByCustomerId(cust.id, 'mb', cust.type)) | numeral('0,0[.]0')
                        }}
                    </td>
                </tr>
                </tbody>
                <tfoot v-if="!_.isEmpty(report_customers)">
                <tr>
                    <th></th>
                    <th class="text-align-right" v-if="!!user_info.user_configs.display_mn || !!user_info.user_configs.display_mn_mtay || !!user_info.user_configs.display_mn_buonme">
                        {{ getSumProfitRegion('mn') | numeral('0,0[.]0') }}
                    </th>
                    <th class="text-align-right" v-if="!!user_info.user_configs.display_mt || !!user_info.user_configs.display_mt_mtay || !!user_info.user_configs.display_mt_buonme">
                        {{ getSumProfitRegion('mt') | numeral('0,0[.]0') }}
                    </th>
                    <th class="text-align-right" v-if="!!user_info.user_configs.display_mb || !!user_info.user_configs.display_mb_mtay || !!user_info.user_configs.display_mb_ngan || !!user_info.user_configs.display_mb_buonme">
                        {{ getSumProfitRegion('mb') | numeral('0,0[.]0') }}
                    </th>
                    <th class="text-align-right" :class="{'text-color-forestgreen': sum_profit >= 0, 'text-color-crimson': sum_profit < 0}">
                        {{ sum_profit | numeral('0,0[.]0') }}
                    </th>
                </tr>
                </tfoot>
            </table>
        </div>
        <Footer :active="'report'"/>
    </f7-page>
</template>
<script>
import Footer from "@/components/Footer";
import moment from "moment-timezone";
import { mapState } from 'vuex';

export default {
    components: {
        Footer
    },
    data() {
        return {
            report_date: new Date(),
            report_date_to: new Date(),
            report: {},
            tab_active: 'today',
            report_date_string: ''
        }
    },
    computed: {
        ...mapState(['user_info', 'customers']),
        sum_profit() {
            return this.getSumProfitRegion('mn') + this.getSumProfitRegion('mt') + this.getSumProfitRegion('mb');
        },
        report_customers() {
            if (this._.isEmpty(this.report.list_messages)) {
                return [];
            }
            return this._.uniqBy(this.report.list_messages, 'customer_id');
        }
    },
    methods: {
        getReport(from_date, to_date) {
            if (moment(from_date).format('YYYY-MM-DD') === moment(to_date).format('YYYY-MM-DD')){
                this.report_date_string = moment(from_date).format('DD/MM/YYYY');
            } else {
                this.report_date_string = moment(from_date).format('DD/MM/YYYY') + ' đến ' + moment(to_date).format('DD/MM/YYYY');
            }

            this.$f7.preloader.show();

            this.$store.dispatch('getReport', {
                from_drawdate: moment(from_date).format('YYYY-MM-DD'),
                to_drawdate: moment(to_date).format('YYYY-MM-DD'),
                flag_optimize_messages: true
            }).then((data) => {
                this.$f7.preloader.hide();
                this.report = data;
            }).catch(() => {
                this.$f7.preloader.hide();
                this.report = {};
            });
        },
        getReportThisWeek() {
            let from_date = moment().tz('Asia/Ho_Chi_Minh').startOf('isoWeek').format('YYYY-MM-DD');
            let to_date = moment().tz('Asia/Ho_Chi_Minh').endOf('isoWeek').format('YYYY-MM-DD');

            this.getReport(from_date, to_date);
        },
        getReportLastWeek() {
            let from_date = moment().tz('Asia/Ho_Chi_Minh').subtract(1, 'week').startOf('isoWeek').format('YYYY-MM-DD');
            let to_date = moment().tz('Asia/Ho_Chi_Minh').subtract(1, 'week').endOf('isoWeek').format('YYYY-MM-DD');

            this.getReport(from_date, to_date);
        },
        getSumProfitRegion(region) {
            let sum = 0;

            this._.each(this.customers, (customer) => {
                sum += this.getSumByCustomerId(customer.id, region, customer.type);
            });

            return sum;
        },
        getSumByCustomerId(customer_id, region, type) {
            if (this._.isEmpty(this.report.list_messages)) {
                return 0;
            }

            let sum = 0;

            this._.each(this.report.list_messages, (msg) => {
                if (msg.customer_id === customer_id) {
                    if (!!region && msg.region !== region) {
                        return;
                    }

                    // if(!this._.isUndefined(msg.report_json['1c'].result.ngang)){
                    //   sum += msg.report_json['1c'].result.ngang;
                    // }

                    sum += msg.report_json['2c'].result.baolo;
                    sum += msg.report_json['2c'].result.baylo;
                    sum += msg.report_json['2c'].result.tamlo;
                    sum += (this._.isNumber(msg.report_json['2c'].result.ui)) ? msg.report_json['2c'].result.ui : 0;
                    sum += msg.report_json['2c'].result.dau;
                    sum += msg.report_json['2c'].result.duoi;
                    sum += msg.report_json['2c'].result.dat;
                    sum += msg.report_json['2c'].result.dx;
                    sum += msg.report_json['2c'].result.dx_2;
                    sum += msg.report_json['2c'].result.dx_3;
                    sum += msg.report_json['2c'].result.dx_4;
                    sum += (!this._.isUndefined(msg.report_json['2c'].result.ke)) ? msg.report_json['2c'].result.ke : 0;

                    sum += msg.report_json['3c'].result.baolo;
                    sum += msg.report_json['3c'].result.baylo;
                    sum += msg.report_json['3c'].result.dau;
                    sum += msg.report_json['3c'].result.duoi;
                    sum += msg.report_json['3c'].result.dat;
                    sum += msg.report_json['3c'].result.dx;
                    sum += (!this._.isUndefined(msg.report_json['3c'].result.ke)) ? msg.report_json['3c'].result.ke : 0;

                    sum += msg.report_json['4c'].result.baolo;
                    sum += msg.report_json['4c'].result.baylo;
                    sum += msg.report_json['4c'].result.dau;
                    sum += msg.report_json['4c'].result.duoi;
                    sum += msg.report_json['4c'].result.dat;
                    sum += msg.report_json['4c'].result.dx;
                }
            });

            let customer = this._.find(this.customers, { 'id': customer_id });

            if (!this._.isUndefined(customer) && !this._.isUndefined(customer.config_deal) && !this._.isUndefined(customer.config_deal[region])) {
                let line_percent = 0;
                if (type === 2 && sum < 0) {
                    line_percent = customer.config_deal[region].line_percent;
                }
                else if (type === 1 && sum > 0) {
                    line_percent = customer.config_deal[region].line_percent;
                }
                if (line_percent > 0) {
                    sum = sum - (sum * line_percent / 100);
                }
            }

            return Math.round(sum);
        }
    },
    watch: {
        report_date() {
            if (this.tab_active === 'today'){
                this.getReport(this.report_date, this.report_date);
            } else {
                this.getReport(this.report_date, this.report_date_to);
            }
        },
        report_date_to() {
            this.getReport(this.report_date, this.report_date_to);
        }
    },
    mounted() {

    }
};
</script>
